module.exports = __webpack_public_path__ + "static/media/delayed trips.6a04dcca.svg";